module.exports = __webpack_public_path__ + "img/OHY.962b7ae1.png";